const firebaseConfig = {
  apiKey: "AIzaSyDXUM-zjjKEgCrsRzPWOQ0PQm67ltQsZxc",
  authDomain: "creative-agency-m.firebaseapp.com",
  databaseURL: "https://creative-agency-m.firebaseio.com",
  projectId: "creative-agency-m",
  storageBucket: "creative-agency-m.appspot.com",
  messagingSenderId: "491726280431",
  appId: "1:491726280431:web:2e736de875e23be1962d1a"
};

export default firebaseConfig;